import {
  CircleDollarSign,
  Coins,
  GraduationCap,
  Info,
  Split,
} from "@tamagui/lucide-icons";
import type { LearnAboutInfo } from "../LearnScreen";

export const ExpenseLearnMore: LearnAboutInfo[] = [
  {
    titleIcon: Coins,
    title: "Expenses",
    subtitle: "Split expenses and settle up when it suits you",
    image: require("../../../../web_legacy/static/expenses_card_preview.webp"),
    featureList: [
      {
        icon: CircleDollarSign,
        text: "1. Add your expenses during the trip",
      },
      {
        icon: Split,
        text: "2. You can choose to split equally or set custom splits",
      },
      {
        icon: Coins,
        text: "3. Settle up at any time",
      },
    ],
    descriptions: [
      {
        icon: Info,
        title: "What is it?",
        description:
          "Effortlessly manage group expenses with Planira's Expenses card, tracking shared costs, fairly splitting bills, and settling debts with minimal fuss.",
      },
      {
        icon: GraduationCap,
        title: "How does this work?",
        description:
          "We use the 'greedy algorithm' to efficiently settle debts among users by minimizing the number of transactions required.",
      },
    ],
  },
];
